import Select from './Select';

export type Option = {
	value: any;
	label: any;
};

export default Select;
